export default "### Cash preservation\n\nAccessing finance means you don’t need to dip into your savings.\n";